import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SurveyMenuPage } from './survey-menu';

@NgModule({
  declarations: [
    SurveyMenuPage,
  ],
  imports: [
    IonicPageModule.forChild(SurveyMenuPage),
  ],
})
export class SurveyMenuPageModule {}



// WEBPACK FOOTER //
// ./src/pages/survey-menu/survey-menu.module.ts